import _styled from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import styled from "styled-components";
import { observer } from "mobx-react";
import { getName } from "../../../../../ModelMixins/CatalogMemberMixin";
import Box from "../../../../../Styled/Box";
import Ul, { Li } from "../../../../../Styled/List";
import Text from "../../../../../Styled/Text";
import { isShareable } from "../BuildShareLink";
import Spacing from "../../../../../Styled/Spacing";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const WarningBox = styled(Box).attrs({
  paddedRatio: 2,
  rounded: true,
  column: true
}).withConfig({
  displayName: "ShareUrlWarning__WarningBox",
  componentId: "sc-1bamihl-0"
})(["background:", ";color:", ";"], props => props.theme.infoColor, props => props.theme.dark);
const WarningLink = styled.a.withConfig({
  displayName: "ShareUrlWarning__WarningLink",
  componentId: "sc-1bamihl-1"
})(["color:", ";text-decoration:underline;cursor:pointer;"], props => props.theme.dark);
export const ShareUrlWarning = observer(_ref => {
  let {
    terria,
    viewState,
    callback
  } = _ref;
  const {
    t
  } = useTranslation();
  const unshareableItems = terria.catalog.userAddedDataGroup.memberModels.filter(model => !isShareable(terria)(model.uniqueId || ""));
  if (unshareableItems.length === 0) {
    return null;
  }
  const addWebData = () => {
    viewState.openUserData();
    callback();
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Spacing, {
      bottom: 2
    }), /*#__PURE__*/_jsxs(WarningBox, {
      children: [/*#__PURE__*/_jsxs(Trans, {
        t: t,
        i18nKey: "share.localDataNote",
        children: [/*#__PURE__*/_jsx(Text, {
          bold: true,
          children: /*#__PURE__*/_jsx("strong", {
            children: "Note:"
          })
        }), /*#__PURE__*/_jsxs(Text, {
          children: ["The following data sources will NOT be shared because they include data from this local system or from an authenticated online service. To share these data sources, publish their data on a web server and", " ", /*#__PURE__*/_jsx(WarningLink, {
            onClick: addWebData,
            children: "add them using a url"
          }), "."]
        })]
      }), /*#__PURE__*/_jsx(_StyledUl, {
        children: unshareableItems.map((item, i) => {
          return /*#__PURE__*/_jsx(Li, {
            children: /*#__PURE__*/_jsx("strong", {
              children: getName(item)
            })
          }, i);
        })
      })]
    }), /*#__PURE__*/_jsx(Spacing, {
      bottom: 2
    })]
  });
});
var _StyledUl = styled(Ul).withConfig({
  displayName: "ShareUrlWarning___StyledUl",
  componentId: "sc-1bamihl-2"
})(["padding:0;"]);